exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".layout[data-v-84d011f2]{display:flex;flex-direction:column;min-height:100vh}.layout__inner[data-v-84d011f2]{flex-grow:1}.layout[data-v-84d011f2] .sidebar__toggle{background:#f48922;bottom:84px;right:13px}@media screen and (max-width:767px){.layout[data-v-84d011f2] .sidebar__title{background:#f48922}}", ""]);

